export enum OTP_ACTION_TYPES {
  GET_OTP = "otp/get_otp",
  GET_OTP_FINISHED = "otp/get_otp_finished",
}

export enum OTP_LOADING_TYPES {
  GET_OTP = "loading/get_otp",
}

export enum OTP_ERROR_TYPES {
  GET_OTP = "error/get_otp",
}

export enum OTP_TYP {
  REGISTRATION = 1,
}
